export const serviceLevels = [
  {
    id: "basic",
    name: "Basic",
    multiplier: 1.0,
    badge: "BASIC",
    description: "Essential cleaning for maintained homes",
    features: [
      "Vacuum & mop floors",
      "Dust surfaces",
      "Basic bathroom clean",
      "Kitchen surfaces"
    ]
  },
  {
    id: "standard",
    name: "Standard",
    multiplier: 1.15,
    badge: "STANDARD",
    description: "Comprehensive cleaning service",
    features: [
      "Everything in Basic",
      "Detailed bathroom clean",
      "Kitchen appliance exterior",
      "Skirting boards",
      "Window sills"
    ],
    popular: true
  },
  {
    id: "plus",
    name: "Plus",
    multiplier: 1.3,
    badge: "PLUS",
    description: "Enhanced deep cleaning",
    features: [
      "Everything in Standard",
      "Inside cupboards",
      "Behind appliances",
      "Detailed dusting",
      "Light switches & handles"
    ]
  },
  {
    id: "premium",
    name: "Premium",
    multiplier: 1.5,
    badge: "PREMIUM",
    description: "Ultimate professional clean",
    features: [
      "Everything in Plus",
      "Inside oven & fridge",
      "Internal windows",
      "Detailed grout cleaning",
      "Full property deep clean"
    ]
  }
];

export const addOns = [
  {
    id: "deep-clean",
    name: "Deep Clean",
    price: 40,
    icon: "ri-brush-line",
    description: "Intensive cleaning of all areas"
  },
  {
    id: "oven",
    name: "Oven Clean",
    price: 15,
    icon: "ri-fire-line",
    description: "Professional oven deep clean"
  },
  {
    id: "fridge",
    name: "Fridge Clean",
    price: 10,
    icon: "ri-fridge-line",
    description: "Full fridge interior clean"
  },
  {
    id: "windows",
    name: "Window Cleaning",
    price: 25,
    icon: "ri-window-line",
    description: "Internal window cleaning"
  },
  {
    id: "eco",
    name: "Eco Products",
    price: 8,
    icon: "ri-leaf-line",
    description: "Premium eco-friendly products"
  },
  {
    id: "urgent",
    name: "Urgent Booking",
    price: 20,
    icon: "ri-time-line",
    description: "Within 24 hours"
  }
];

export const propertyTypes = [
  { id: "flat", name: "Flat", icon: "ri-building-line" },
  { id: "house", name: "House", icon: "ri-home-line" },
  { id: "office", name: "Office", icon: "ri-briefcase-line" }
];

export const frequencies = [
  { id: "one-off", name: "One-off" },
  { id: "weekly", name: "Weekly" },
  { id: "bi-weekly", name: "Bi-weekly" },
  { id: "monthly", name: "Monthly" }
];